module.exports = __webpack_public_path__ + "img/app_scan_icon.ebf96a9b.png";